//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Input, Autocomplete} from 'element-ui'

Vue.use(Input)
Vue.use(Autocomplete)

export default {
  name: 'CyHeader',
  components: {},
  props: {
    logoText: {
      type: String,
      required: false
    },
    logoMiniText: {
      type: String,
      required: false
    },
    user: {
      staffId: '',
      staffName: '',
      menuList: []
    }
  },
  data () {
    return {
      restaurants: [],
      state: '',
      msgCount: '',
      aplCount: '',
      unSubFeeCount: ''
    }
  },
  mounted () {
    this.restaurants = this.loadAll()
  },
  methods: {
    querySearch (queryString, cb) {
      let restaurants = this.restaurants
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      console.log(results)
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    loadAll () {
      return [
        {'value': '三全鲜食（北新泾店）', 'address': '长宁区新渔路144号'},
        {'value': 'Hot honey 首尔炸鸡（仙霞路）', 'address': '上海市长宁区淞虹路661号'},
        {'value': '新旺角茶餐厅', 'address': '上海市普陀区真北路988号创邑金沙谷6号楼113'},
        {'value': '泷千家(天山西路店)', 'address': '天山西路438号'},
        {'value': '胖仙女纸杯蛋糕（上海凌空店）', 'address': '上海市长宁区金钟路968号1幢18号楼一层商铺18-101'}
      ]
    },
    handleSelect (item) {
      console.log('handleSelect')
      console.log(item)
      if (item.value === '' && this.restaurants.length > 0) {
        this.state = this.restaurants[0].value
      }
    },
    enterHandleSelect () {
      console.log('enterHandleSelect')
      console.log(this.restaurants[0])
      this.state = this.restaurants[0].value
    },
    handleIconClick (ev) {
      console.log(ev)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mobile/CyMobileHeader.vue